import { apiUrl } from "../config";

/**
 * Get Basic Auth headers from localStorage
 */
const getAuthHeaders = () => {
  const storedAuth = localStorage.getItem('adminAuth');
  if (!storedAuth) {
    return {};
  }

  try {
    const { username, password } = JSON.parse(storedAuth);
    return {
      'Authorization': `Basic ${btoa(`${username}:${password}`)}`,
    };
  } catch (e) {
    return {};
  }
};

/**
 * @returns {Promise<Array>}
 */
export const getResponses = async () => {
  try {
    const response = await fetch(apiUrl("/admin/responses"), {
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      throw new Error(`Error fetching responses json: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to fetch admin responses json:", error);
  }
}

/**
 * @param {string} startDate - Optional start date (YYYY-MM-DD format)
 * @param {string} endDate - Optional end date (YYYY-MM-DD format)
 * @returns {Promise<Blob>}
 */
export const getResponsesCsv = async (startDate = null, endDate = null) => {
  try {
    const params = new URLSearchParams();
    if (startDate) {
      params.append('startDate', startDate);
    }
    if (endDate) {
      params.append('endDate', endDate);
    }

    const url = apiUrl("/admin/responses/csv") + (params.toString() ? `?${params.toString()}` : '');
    const response = await fetch(url, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      throw new Error(`Error fetching responses csv: ${response.statusText}`);
    }

    return await response.blob();
  } catch (error) {
    console.error("Failed to fetch admin responses csv:", error);
  }
}
